/*
 * @Author: EdwardYoung
 * @Date: 2017-08-01 16:15:51
 * @Last Modified by: EdwardYoung
 * @Last Modified time: 2017-09-16 02:53:14
 */

import {isFirstExecute} from 'common/util/isFirstExecute'

/**
 * 初始化订单详情页
 */

function initBeforePay () {
  (function (yhsd) {
    let _isBargainOrderAndModifyDom = isFirstExecute(isBargainOrderAndModifyDom)
    return yhsd.ready(function (sdk) {
      return sdk
        .events
        .subscribe('component.render.completed', function () {
          _isBargainOrderAndModifyDom()
        })
    })
  })(window.yhsd)
}

/**
 * 该订单是否是砍价后的订单, 是修改dom
 */
async function isBargainOrderAndModifyDom () {
  let pathnameStr = window.location.pathname
  let orderNumber = ''
  let amountAfter = ''
  if (pathnameStr.indexOf('/account/orders') !== -1) {
    orderNumber = getOrderNumber()
    amountAfter = await getBargainPriceValue(orderNumber)
  }
  //  存在订单号和砍价价格则修改订单详情页
  if (orderNumber && amountAfter) {
    if (isPcVisit()) {
      modifyPCOrderList(amountAfter)
    } else {
      modifyOrderList(amountAfter)
    }
  }
}

/**
 * 获取订单号
 */
function getOrderNumber () {
  let pathnameStr = window.location.pathname
  let pathnameArray = pathnameStr.split('/')
  const orderId = pathnameArray[3]
  return orderId
}

/**
 * 获取砍价后的价格
 */
async function getBargainPriceValue (id) {
  return new Promise((resolve, reject) => {
    (function (yhsd) {
      return yhsd.ready(function (sdk) {
        return sdk
          .order
          .get(id, function (obj) {
            const key = `kanjia_amount_after_${obj.res.order.id}`
            resolve(obj.res.order.metas[key]['amount_after'])
          })
      })
    })(window.yhsd)
  })
}

/**
 * 修改下单列表dom
 */
function modifyOrderList (amountAfter) {
  amountAfter = ((amountAfter - 0) / 100 + 1e-6).toFixed(2)
  //  获取商品金额总计
  let moneyArray = Array
    .prototype
    .slice
    .call(document.querySelectorAll('.table-view-cell.table-view-cell-noborder'), 0)

  let oldMoneyDom = moneyArray[0]
  let oldMoneyLastDom = oldMoneyDom.lastElementChild
  let oldMoneyLastDomTextContent = oldMoneyLastDom.textContent
  let oldMoney = oldMoneyLastDomTextContent.split('¥')[1] - 0

  //  商品金额总计newDom
  let oldMoneyNewDom = moneyArray[0].cloneNode(true)
  oldMoneyNewDom.firstElementChild.textContent = `商品金额总计`
  oldMoneyNewDom.lastElementChild.textContent = `¥${oldMoney.toFixed(2)}`

  //  获取运费总计
  let freightDom = moneyArray[1]
  let freightLastDom = freightDom.lastElementChild
  let freightLastDomTextContent = freightLastDom.textContent
  let freight = freightLastDomTextContent.split('¥')[1] - 0

  //  运费总计newDom
  let freightNewDom = moneyArray[1].cloneNode(true)
  freightNewDom.firstElementChild.textContent = `运费总计`
  freightNewDom.lastElementChild.textContent = `¥${freight.toFixed(2)}`

  //  应付总额newDom
  let payNew = ((freight * 100 + amountAfter * 100 + 1e-6) / 100).toFixed(2)
  let payNewDom = moneyArray[moneyArray.length - 1].cloneNode(true)
  payNewDom.firstElementChild.textContent = `应付总额`
  payNewDom.lastElementChild.textContent = `¥${payNew}`

  //  如果砍掉的钱大于商品价格，砍掉金额newDom
  let bargainMoney = ((oldMoney * 100 + freight * 100 - payNew * 100 + 1e-6) / 100).toFixed(2)
  let bargainDom = moneyArray[1].cloneNode(true)
  bargainDom.firstElementChild.textContent = `砍价活动优惠`
  bargainDom.lastElementChild.textContent = `¥${bargainMoney}`

  // 原有dom全部隐藏
  for (const item of moneyArray) {
    item.style.display = 'none'
  }

  //  插入ul中
  let moneyulDom = document.querySelector('.table-view.order-bill')
  moneyulDom.appendChild(oldMoneyNewDom)
  moneyulDom.appendChild(freightNewDom)
  moneyulDom.appendChild(bargainDom)
  moneyulDom.appendChild(payNewDom)
}

/**
 * 修改PC下单列表dom
 */
function modifyPCOrderList (amountAfter) {
  amountAfter = ((amountAfter - 0) / 100 + 1e-6).toFixed(2)
  //  获取商品金额总计
  let moneyArray = Array
    .prototype
    .slice
    .call(document.querySelector('.detail').children, 0)

  let oldMoneyDom = moneyArray[0]
  let oldMoneyLastDom = oldMoneyDom.lastChild
  let oldMoneyLastDomTextContent = oldMoneyLastDom.textContent
  let oldMoney = oldMoneyLastDomTextContent.split('¥')[1] - 0

  //  商品金额总计newDom
  let oldMoneyNewDom = moneyArray[0].cloneNode(true)
  oldMoneyNewDom.firstChild.textContent = `商品金额总计`
  oldMoneyNewDom.lastChild.textContent = `¥${oldMoney.toFixed(2)}`

  //  获取运费总计
  let freightDom = moneyArray[1]
  let freightLastDom = freightDom.lastChild
  let freightLastDomTextContent = freightLastDom.textContent
  let freight = freightLastDomTextContent.split('¥')[1] - 0

  //  运费总计newDom
  let freightNewDom = moneyArray[1].cloneNode(true)
  freightNewDom.firstChild.textContent = `运费总计`
  freightNewDom.lastChild.textContent = `¥${freight.toFixed(2)}`

  //  应付总额newDom
  let payNew = ((freight * 100 + amountAfter * 100 + 1e-6) / 100).toFixed(2)
  let payNewDom = moneyArray[moneyArray.length - 1].cloneNode(true)
  payNewDom.firstChild.textContent = `应付总额`
  payNewDom.lastChild.textContent = `¥${payNew}`

  //  如果砍掉的钱大于商品价格，砍掉金额newDom
  let bargainMoney = ((oldMoney * 100 + freight * 100 - payNew * 100 + 1e-6) / 100).toFixed(2)
  let bargainDom = moneyArray[1].cloneNode(true)
  bargainDom.firstChild.textContent = `砍价活动优惠`
  bargainDom.lastChild.textContent = `¥${bargainMoney}`

  // 原有dom全部隐藏
  for (const item of moneyArray) {
    item.style.display = 'none'
  }

  //  插入ul中
  let moneyulDom = document.querySelector('.detail')
  moneyulDom.appendChild(oldMoneyNewDom)
  moneyulDom.appendChild(freightNewDom)
  moneyulDom.appendChild(bargainDom)
  moneyulDom.appendChild(payNewDom)
}

/**
 * 根据dom判断当前提交订单页是否是pc端
 */
function isPcVisit () {
  if (document.querySelector('.detail')) {
    return true
  } else {
    return false
  }
}

export {initBeforePay}



// WEBPACK FOOTER //
// ./src/api/InitBeforePay.js